import { pipe } from 'fp-ts/lib/function';
import { array, failure, parse, success } from 'io-ts/Decoder';

import { Point } from './Point';

export const Line = pipe(
	array(Point),
	parse((points) =>
		points.length === 2 ? success(points) : failure(points, 'Line must have exactly 2 points')
	)
);
